module.exports = __webpack_public_path__ + "img/carshina22_20.b848ccff.jpg";